import { Component, OnInit, Input, Output, forwardRef, EventEmitter, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { AppService } from 'src/modules/base/shared/services/app.service';

@Component({
    selector: 'dhs-tickets',
    templateUrl: './tickets.component.html',
    styleUrls: ['./tickets.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TicketsComponent),
            multi: true
        }],
    standalone: false
})
export class TicketsComponent implements ControlValueAccessor, OnInit {
  @Input('value') _value: any;
  @Output() valueChange = new EventEmitter<any>();
  propagateChange = (_: any) => { };
  onTouched: any = () => { };
  question: any;
  isSystemUser: boolean = false;

  constructor(private readonly appService: AppService) {
  }
  ngOnInit() {
    this.isSystemUser = this.appService.getCurrentUser()?.user_type == 'system_user';
    if (!this.question) {
      this.question = {};
    }

    this.question["s3Document"] = true;
    this.question["resource"] = "helpdesk_documents";

  }
  // extractNotes(notes: string): string[] {
  //   let regex = /<li>(.*?)<\/li>/g;
  //   let matches = notes.match(regex);
  //   if (matches) {
  //     return matches.map(match => match.replace(/<\/?li>/g, '').trim());
  //   }
  //   return [];
  // }
  get value(): any {
    // var val = [
    //   {
    //     "created_by": "cdb922a0-bbc0-11ec-8782-7e8c27ee3414-47",
    //     "created_by_name": "Bl Admin",
    //     "notes": "Thank you for reaching out | KareXpert (Autoresponder)",
    //     "role": "Facility Admin",
    //     "current_stage": "Open",
    //     "creation_time": 1659438452722,
    //     "documents": [
    //       {
    //         "documentId": "62e9052011bf5113420766b8",
    //         "id": "4e955b38-1253-11ed-b157-c601bfd135ef-60"
    //       },
    //       {
    //         "documentId": "62e9055811bf5113420766bf",
    //         "id": "4e955b39-1253-11ed-b157-c601bfd135ef-61"
    //       },
    //       {
    //         "documentId": "62e9055811bf5113420766c1",
    //         "id": "4e955b3a-1253-11ed-b157-c601bfd135ef-62"
    //       },
    //       {
    //         "documentId": "62e905581d7e232f9f36b7e9",
    //         "id": "4e955b3b-1253-11ed-b157-c601bfd135ef-63"
    //       },
    //       {
    //         "documentId": "62e9055811bf5113420766cd",
    //         "id": "4e955b3c-1253-11ed-b157-c601bfd135ef-64"
    //       },
    //       {
    //         "documentId": "62e905581d7e232f9f36b7eb",
    //         "id": "4e955b3d-1253-11ed-b157-c601bfd135ef-65"
    //       }
    //     ]
    //   },
    //   {
    //     "created_by": "da17dbd0-46be-11ec-9e05-167f077aa513-92",
    //     "created_by_name": "Ankitaa",
    //     "notes": "lklj",
    //     "role": "Helpdesk Manager",
    //     "previous_stage": "Open",
    //     "current_stage": "Assign to Team",
    //     "creation_time": 1659438807650
    //   },
    //   {
    //     "created_by": "da17dbd0-46be-11ec-9e05-167f077aa513-92",
    //     "created_by_name": "Ankitaa",
    //     "notes": "bchg",
    //     "role": "Helpdesk Manager",
    //     "previous_stage": "Assign to Team",
    //     "current_stage": "Assign to Kx Team",
    //     "creation_time": 1659438860319
    //   },
    //   {
    //     "created_by": "ddc877d0-114d-11ed-ac2b-4ec97aee6529-12",
    //     "created_by_name": "Customer Success Manager",
    //     "notes": "please check",
    //     "role": "Customer Success Manager",
    //     "team_name": "Rahul",
    //     "previous_stage": "Assign to Kx Team",
    //     "current_stage": "Assign to Kx Team",
    //     "creation_time": 1659439298539,
    //     "documents": [
    //       {
    //         "documentId": "62e908c01d7e232f9f36b7ee",
    //         "id": "46b376d2-1255-11ed-958a-9e4e7117f97f-33"
    //       }
    //     ]
    //   },
    //   {
    //     "created_by": "5773c6c0-114e-11ed-9911-eab16959f238-55",
    //     "created_by_name": "Customer Success Team",
    //     "notes": "Please check",
    //     "role": "Customer Success Team",
    //     "team_name": "Shiva",
    //     "previous_stage": "Assign to Kx Team",
    //     "current_stage": "Assign to Kx Team",
    //     "creation_time": 1659439411892
    //   },
    //   {
    //     "created_by": "9dcbe4e0-114e-11ed-ac2b-4ec97aee6529-16",
    //     "created_by_name": "Product Success Manager",
    //     "notes": "Please chek",
    //     "role": "Product Success Manager",
    //     "team_name": "Pawan",
    //     "previous_stage": "Assign to Kx Team",
    //     "current_stage": "Assign to Kx Team",
    //     "creation_time": 1659439563660,
    //     "documents": [
    //       {
    //         "documentId": "62e9098f11bf5113420766cf",
    //         "id": "e4c3ca05-1255-11ed-b157-c601bfd135ef-85"
    //       }
    //     ]
    //   },
    //   {
    //     "created_by": "9dcbe4e0-114e-11ed-ac2b-4ec97aee6529-16",
    //     "created_by_name": "Product Success Manager",
    //     "role": "Product Success Manager",
    //     "previous_stage": "Assign to Kx Team",
    //     "current_stage": "Assign To Development Team",
    //     "open_project_id": "7895600",
    //     "creation_time": 1659439614670
    //   },
    //   {
    //     "created_by": "9dcbe4e0-114e-11ed-ac2b-4ec97aee6529-16",
    //     "created_by_name": "Product Success Manager",
    //     "role": "Product Success Manager",
    //     "previous_stage": "Assign To Development Team",
    //     "current_stage": "Resolved",
    //     "creation_time": 1659439644993
    //   }
    // ];
    // this._value = val;
    return this._value;
  }

  set value(val) {
    this._value = val;
     // Convert timestamps inside notes
    if (this._value && Array.isArray(this._value)) {
      this._value.forEach(field => {
        if (field.notes) {
          field.notes = this.convertLongToDate(field.notes);
        }
      });
    }

    this.propagateChange(val);
    this.onTouched();
  }

  writeValue(value) {
    if (value) {
      this.value = value;
      this.setvalueForUpdate(this.value);
    }
    this.propagateChange(value);
  }

  setvalueForUpdate(value) {
  }
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
  
  // Change notes of an activity; entries flagged hide_from_client are shown only to system users
  visibleNotes(field: any): any[] {
    const notes = Array.isArray(field?.notes_json) ? field.notes_json : [];
    return notes.filter(note => this.isSystemUser || note.hide_from_client !== true);
  }

  convertLongToDate(notes: string): string {
    return notes.replace(/\d{13}/g, (match) => {
      const date = new Date(Number(match));
      const formattedDate =
        ('0' + date.getDate()).slice(-2) + '/' +
        ('0' + (date.getMonth() + 1)).slice(-2) + '/' +
        date.getFullYear();
      return formattedDate;
    });
  }
}